import { handleMessage, requestMessage } from '@business/messages';
import { BaseBloc } from '@core/utils/bloc';
import { Repository } from '@core/utils/repository';
import { CompanyPolicyResponse, CompactCompanyPolicyResponse, CompanyPolicyId, FolderId } from '@business/entities/library';
import { CompanyId } from '@business/entities/companies';
import { CompanyPolicyAPI } from '@business/api/company_policy';
import { showDeleteConfirmation } from '@modules/common';
import { switchMap } from 'rxjs/operators';
import { LibraryItemType } from '@business/entities/library';

export class CompanyPolicyBloc extends BaseBloc {
  private readonly companyPolicyRepo = new Repository<CompanyPolicyResponse | CompactCompanyPolicyResponse>({
    getItemId: item => item.id,
  });

  readonly companyPolicys = this.companyPolicyRepo.items;
  readonly allCompanyPolicies$ = this.companyPolicyRepo.items$;
  readonly selectAdminScale = this.companyPolicyRepo.selectItem;

  onReset() {
    this.companyPolicyRepo.reset();
  }

  fetchCompanyPolicies = (companyId: CompanyId, isCompact?: boolean, type?: LibraryItemType) => {
    return CompanyPolicyAPI.fetchCompanyPolicies(companyId, isCompact).pipe(
      this.companyPolicyRepo.ops.reset(),
      handleMessage({ error: requestMessage('fetch_companypolicy_error') }),
    );
  };

  fetchCompanyPolicy = (id: CompanyPolicyId) => {
    return CompanyPolicyAPI.fetchCompanyPolicy(id).pipe(
      this.companyPolicyRepo.ops.upsertOne(item => ({ item })),
      handleMessage({ error: requestMessage('fetch_companypolicy_error') }),
    );
  };

  createCompanyPolicy = (data: Partial<CompanyPolicyResponse>) => {
    return CompanyPolicyAPI.createCompanyPolicy(data).pipe(
      this.companyPolicyRepo.ops.addOne(item => item),
      handleMessage({
        type: requestMessage('create_companypolicy'),
      }),
    );
  };

  updateCompanyPolicy = (id: CompanyPolicyId, data: Partial<CompanyPolicyResponse>) => {
    return CompanyPolicyAPI.updateCompanyPolicy(id, data).pipe(
      this.companyPolicyRepo.ops.upsertOne(item => ({ item })),
      handleMessage({
        type: requestMessage('update_companypolicy'),
      }),
    );
  };

  deleteCompanyPolicy = (id: CompanyPolicyId) => {
    return showDeleteConfirmation('Delete Admin Scale', 'Do you really want to remove this Admin Scale?').pipe(
      switchMap(() => CompanyPolicyAPI.deleteCompanyPolicy(id)),
      this.companyPolicyRepo.ops.removeOne(() => id),
      handleMessage({
        type: requestMessage('delete_companypolicy'),
      }),
    );
  };

  createFolder = (name: string, parentId?: FolderId) => {
    return CompanyPolicyAPI.createFolder(name, parentId).pipe(
      this.companyPolicyRepo.ops.addOne(item => item),
      // handleMessage({
      //   type: requestMessage('create_folder'),
      // }),
    );
  };
  
}
